import React from "react";
import { GiftIcon, CheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
import { bonuses } from "../data/content";
export function Bonuses() {
  return <section className="bg-canvas py-16 sm:px-6 sm:py-20" data-id="element-66" data-mp="aua4y8rf39qx">
      <div className="mx-auto max-w-4xl" data-id="element-67" data-mp="ftwikjb5qs09">
        <div className="px-4 sm:px-0" data-id="element-68" data-mp="fslgqp19vubs">
          <SectionHeading kicker="5 exclusive bonuses — included free" title="Get These Five Additional Tools with Your Purchase" subtitle="Resources that make it easier to use the blueprint in everyday workshop situations—at no extra cost." data-id="element-69" data-mp="1uet01q1fapu" />
        </div>

        <div className="mt-10 space-y-8" data-id="element-70" data-mp="3t0ogy264l9mo">
          {bonuses.map(b => <article key={b.number} className="overflow-hidden bg-white shadow-sm sm:rounded-3xl" data-id="element-71" data-mp="3t2snyszbmor6">
              <div className="flex items-center justify-between gap-3 bg-gold px-4 py-3 sm:px-8" data-id="element-72" data-mp="1m85pxy506cq2">
                <span className="flex items-center gap-2 font-display text-lg font-black uppercase text-night" data-id="element-73" data-mp="1r78qb5a1furp">
                  <GiftIcon className="h-5 w-5" aria-hidden="true" data-id="element-74" data-mp="3dfd2vkijy2te" />
                  Bonus #{b.number}
                </span>
                <span className="text-sm font-bold text-night" data-id="element-75" data-mp="3r6zz5kchvbc6">
                  Value: <span className="line-through" data-id="element-76" data-mp="3n54z0j6av3zz">${b.value}</span>{" "}
                  <span className="rounded-md bg-night px-2 py-0.5 text-white" data-id="element-77" data-mp="3n5y83qsqe5la">FREE</span>
                </span>
              </div>
              <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="block w-full" data-id="element-78" data-mp="2ughbegy2w2j9" />
              <div className="px-4 pb-7 pt-2 sm:px-8" data-id="element-79" data-mp="38g8ugw3gc944">
                <h3 className="font-display text-[24px] font-extrabold leading-tight text-ink sm:text-3xl" data-id="element-80" data-mp="38htngha4bjzv">{b.title}</h3>
                <p className="mt-3 text-[16px] leading-relaxed text-ink-soft" data-id="element-81" data-mp="33ja2aj3cmc8k">{b.intro}</p>
                <ul className="mt-4 space-y-2.5" data-id="element-82" data-mp="no6rtpab7iqg">
                  {b.items.map(item => <li key={item} className="flex gap-3 text-[16px] leading-snug text-ink" data-id="element-83" data-mp="iqoqol2ja7t0">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-84" data-mp="3cin00ys8h6bv" />
                      <span data-id="element-85" data-mp="3hg6d3vd73d28">{item}</span>
                    </li>)}
                </ul>
                <p className="mt-4 text-[15px] italic leading-relaxed text-ink-muted" data-id="element-86" data-mp="3lke27tnkev0z">{b.outro}</p>
              </div>
            </article>)}
        </div>

        <div className="mt-10 px-4 sm:px-0" data-id="element-87" data-mp="2ttge72w57ylu">
          <CtaButton label="Get the Blueprint + 5 free bonuses" arrow data-id="element-88" data-mp="2tqc4xr3tmcob" />
        </div>
      </div>
    </section>;
}